import { useEffect, useState, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Spin } from 'antd'
import { useTimer } from 'react-timer-hook'
import { Typography, Button, OTP } from 'mobily-ui-library/lib'
import { getOtp, submitOtp, resendOtp } from '../../api/otpApi'
import { GlobalContext } from '../../context/GlobalContext'
import { orderInquiryApi } from '../../api/api'
import { JSEncrypt } from 'jsencrypt'
import otpBackArrow from '../../assets/otpBackArrow.svg'
import './OtpScreen.scss'

const OtpScreen = () => {
    const { t } = useTranslation();
    const [state, dispatch]: any = useContext(GlobalContext);
    const { rtl, orderNumber, inquiryRes, actionName, selectedOrderDetails } = state;
    const win: any = window;
    const lang = win['lang'];
    var serverURL = win["base_portal_url"];
    var errorPage = win["errorPageURL"];
    const dir = rtl ? "right" : "left";
    const [digits, setDigits] = useState("");
    const [loading, setLoading] = useState(true);
    const [showOTPTimer, setShowOTPTimer] = useState(false);
    const [showOTPError, setShowOTPError] = useState(false);
    const [showOTPStatus, setShowOTPStatus] = useState(true);
    const [hashCode, setHashCode] = useState("");
    let componentToDisplay = <></>;
    let phoneNumber: any = '';
    let moduleId: any = '';
    let encryptedLang= lang.toUpperCase();
    if (orderNumber.startsWith('966') || orderNumber.startsWith('05')) {
        phoneNumber = orderNumber;
        moduleId ="120";
    } else {
        phoneNumber = inquiryRes.orders[0].customerInfo.ReceiverContactNumber;
        moduleId ="121";
    }
    const time = new Date();
    const expiryTimestamp = time;
    const { seconds, minutes, restart, } = useTimer({
        expiryTimestamp, onExpire: () => {
            setShowOTPTimer(false);
        }
    });
    const publicKey = win["bm_rsa_public_key"];
    let jsencrypt = new JSEncrypt();
    jsencrypt.setPublicKey(publicKey);
    useEffect(() => {
      const current = new Date();
      let currentDate = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;
      let pNumber = phoneNumber.charAt(0) === "0" ?  phoneNumber.replace("0", "966") : phoneNumber;
      let paramPhoneNumber = phoneNumber.charAt(0) === "0" ? phoneNumber : phoneNumber.replace("966", "0");
      //encryption
      let currentDateEncrypted = currentDate ? jsencrypt.encrypt(currentDate) : "";
      let pNumberEncrypted =  pNumber ? jsencrypt.encrypt(pNumber) : "";
      let paramPhoneNumberEncrypted = paramPhoneNumber ? jsencrypt.encrypt(paramPhoneNumber) : "";
      let scanEncrypted = "";
      let moduleIdEncrypted = moduleId ? jsencrypt.encrypt(moduleId) : "";
      let langEncrypted = encryptedLang ? jsencrypt.encrypt(encryptedLang) : "";
      let otpLengthEncrypted = jsencrypt.encrypt("4");
      let isNumericEncrypted = jsencrypt.encrypt("Y");
      let verificationEncrypted = jsencrypt.encrypt("Mobile");
      let otpStringEncrypted = jsencrypt.encrypt("OTP");

        getOtp(pNumberEncrypted, paramPhoneNumberEncrypted, currentDateEncrypted, moduleIdEncrypted, scanEncrypted, langEncrypted, otpLengthEncrypted,isNumericEncrypted,verificationEncrypted,otpStringEncrypted).then((response: any) => {
            if (response.status === 204) {
                setLoading(false);
                setHashCode(response.headers.hashcode);
                // setHashCode("123344");
            } else {
                window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
            }
        });
    }, []);

  const digitsHandleChange = (otp: any) => {
    setDigits(otp)
    if (otp.length === 4) {
      onOTPSubmit(otp)
    }
  }

    const onOTPSubmit = (otp: any) => {
        setDigits("");
        setShowOTPTimer(false);
        setShowOTPStatus(false);
        setLoading(true);
        submitOtp(otp, hashCode).then((response: any) => {
            if (response.status === 204) {
                console.log("otp success", hashCode);
                dispatch({ type: "OTP_SCREEN_SUCCESS", payload: { showDetails: 'true', hashCode: hashCode } });
                if (orderNumber.startsWith('966') || orderNumber.startsWith('05')) {
                    dispatch({
                        type: 'TRACK_MY_ORDER_SUCCESS',
                        payload: { orderNumber: orderNumber, phoneNumber: phoneNumber },
                    })
                    dispatch({ type: "GO_TO_SCREEN", payload: { page: 'TrackMyOrder' } });
                } else {
                    if (actionName === t("CHANGE_DELIVERY")) {
                        dispatch({ type: "GO_TO_SCREEN", payload: { page: 'DeliveryDetails' } });
                    } else {
                        dispatch({ type: "GO_TO_SCREEN", payload: { page: 'CancelTransferRequest' } });
                    }
                }
            } else if (response.status === 260) {
                setShowOTPStatus(true);
                setShowOTPError(true);
                setLoading(false);
            } else {
                // go to generic error
                window.location.href = serverURL + errorPage + `?errorSource= ${t('ecommerce')}`;
            }
        });
    }

  const onResendOtp = () => {
    const time = new Date()
    time.setSeconds(time.getSeconds() + 30)
    restart(time)
    setDigits('')
    setShowOTPTimer(true)
    setShowOTPError(false)
    resendOtp(hashCode).then((response: any) => {
      if (response.status === 204) {
      } else {
        // go to generic error
        window.location.href = serverURL + errorPage + `?errorSource= ${t('ecommerce')}`
      }
    })
  }

  const onBackButton = () => {
    if (orderNumber.startsWith('966') || orderNumber.startsWith('05')) {
      dispatch({ type: 'GO_TO_SCREEN', payload: { page: 'TrackMyOrder' } })
    } else {
      dispatch({ type: 'GO_TO_SCREEN', payload: { page: 'OrderDetails' } })
    }
  }

  if (loading) {
    componentToDisplay = <Spin className="spinLoader" size="large" />
  } else {
    componentToDisplay = (
      <>
        <div className="otpScreen_container">
          <div className="otpScreen_BackButton_container">
            <img
              onClick={onBackButton}
              className="otpScreen_closeButton"
              src={otpBackArrow}
              alt="mobilyIcon"
            />
            <div onClick={onBackButton} className="otp_backBtn_text">
              {t('back')}
            </div>
          </div>
          <div className="otpScreen_heading_container">
            <Typography rtl={rtl} className="otpScreen_title">
              {t('we_need_to_know')}
            </Typography>
            <Typography rtl={rtl} className="otpScreen_subTitle">
              
              {t('we_sent_a_one_time_code_to_your_phone', { phone_number: t(phoneNumber) })}
            </Typography>
            <Typography rtl={rtl} className="otpScreen_subTitle_second">
              
              {t('please_enter_it_below')}
            </Typography>
          </div>
          <div className="otpScreen_otp">
            <OTP className='otpClass_otp' numInputs={4} rtl={rtl} onChange={digitsHandleChange} value={digits} />
          </div>
          <div style={{ visibility: showOTPStatus ? 'visible' : 'hidden' }}>
            {showOTPTimer ? (
              <Typography className="OtpSubText" rtl={rtl}>
                {t('new_code_sent')}
                <span style={{ fontWeight: 'bold' }}>
                  <span>{minutes}</span>:<span>{seconds}</span>
                </span>
              </Typography>
            ) : showOTPError ? (
              <Typography className="OtpSubText-Error" rtl={rtl}>
                {t('that_code_not_valid')}
                <span className="resendOTP-Error" onClick={onResendOtp}>
                  {t('send_again')}
                </span>
              </Typography>
            ) : (
              <Typography className="OtpSubText" rtl={rtl}>
                {t('didnot_recive_the_code')}
                <span className="resendOTP" onClick={onResendOtp}>
                  {t('send_again')}
                </span>
              </Typography>
            )}
          </div>
          {/* <Button
                        className={"OtpNextButton"}
                        primary={true}
                        rtl={rtl}
                        onClick={onOTPSubmit}
                        variant={digits.length !== 5 ? 'disabled' : 'default'}
                        htmlType={'submit'}>
                        {t("next")}
                    </Button> */}
        </div>
      </>
    )
  }
  return componentToDisplay
}

export default OtpScreen
